import React from 'react';
import { Theme, Typography, TypographyProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const useStyles = makeStyles((theme: Theme) => ({
	infoLabel: {
		display: 'inline',
		fontWeight: 325,
	},
	text: {
		display: 'inline',
		fontWeight: 325,
		marginLeft: theme.spacing(.25),
	},
	[theme.breakpoints.down('md')]: {
		infoLabel: {
			fontSize: '10px',
		},
		text: {
			fontSize: '10px',
		},
	},
}));

type CaseActivityInfoProps = Partial<TypographyProps> & {
	label: React.ReactNode;
};

const CaseActivityInfo: React.FC<CaseActivityInfoProps> = ({ children, className, ...props }) => {
	const classes = useStyles();

	return (
		<Typography
			variant="caption"
			className={classNames(classes.infoLabel, className)}
			{...props}
		>
			{props.label}
			<Typography
				component="p"
				variant="caption"
				className={classes.text}
			>
				{children}
			</Typography>
		</Typography>
	);
};

export default CaseActivityInfo;
